/* eslint-disable */
export default {
    defaultConfiguration : {
        clientId: '',
        developerKey: '',
        viewId: 'DOCS',
        callbackFunction: function () { return null; },
    }
}